import React from 'react';
import { useIsMobile } from '../utils/useIsMobile';
import { PortfolioChartsToggleProps } from './PortfolioChartsToggle.model';
import { PortfolioChartsToggleDesktop } from './PortfolioChartsToggleDesktop';
import { PortfolioChartsToggleMobile } from './PortfolioChartsToggleMobile';

const PortfolioChartsToggle: React.FC<PortfolioChartsToggleProps> = (props) =>
  useIsMobile() ? <PortfolioChartsToggleMobile {...props} /> : <PortfolioChartsToggleDesktop {...props} />;

export { PortfolioChartsToggle };
